import {
  GET_LABREQUESTTRACKING,
  GET_LABREQUESTTRACKING_FAIL,
  GET_LABREQUESTTRACKING_SUCCESS,
  GET_LABREQUESTTRACKINGS,
  GET_LABREQUESTTRACKINGS_FAIL,
  GET_LABREQUESTTRACKINGS_SUCCESS,
  ADD_NEW_LABREQUESTTRACKING,
  ADD_LABREQUESTTRACKING_SUCCESS,
  ADD_LABREQUESTTRACKING_FAIL,
  UPDATE_LABREQUESTTRACKING,
  UPDATE_LABREQUESTTRACKING_SUCCESS,
  UPDATE_LABREQUESTTRACKING_FAIL,
  DELETE_LABREQUESTTRACKING,
  DELETE_LABREQUESTTRACKING_SUCCESS,
  DELETE_LABREQUESTTRACKING_FAIL,
  SET_STATE_LABREQUESTTRACKING
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTTRACKING,
  payload: loading,
})

export const getLabRequestTrackings = ( params ) => ({
  type: GET_LABREQUESTTRACKINGS,
  payload: { params },
})

export const getLabRequestTrackingsSuccess = (labRequestTrackings, totalPages, currentPage) => ({
  type: GET_LABREQUESTTRACKINGS_SUCCESS,
  payload: { labRequestTrackings:labRequestTrackings, total:totalPages, currentPage:currentPage}
})

export const getLabRequestTrackingsFail = error => ({
  type: GET_LABREQUESTTRACKINGS_FAIL,
  payload: error,
})

export const addNewLabRequestTracking = labRequestTracking => ({
  type: ADD_NEW_LABREQUESTTRACKING,
  payload: labRequestTracking,
})

export const addLabRequestTrackingSuccess = labRequestTracking => ({
  type: ADD_LABREQUESTTRACKING_SUCCESS,
  payload: labRequestTracking,
})  

export const addLabRequestTrackingFail = error => ({
  type: ADD_LABREQUESTTRACKING_FAIL,
  payload: error,
})

export const updateLabRequestTracking = labRequestTracking => ({
  type: UPDATE_LABREQUESTTRACKING,
  payload: labRequestTracking,
})

export const updateLabRequestTrackingSuccess = labRequestTracking => ({
  type: UPDATE_LABREQUESTTRACKING_SUCCESS,
  payload: labRequestTracking,
})

export const updateLabRequestTrackingFail = error => ({
  type: UPDATE_LABREQUESTTRACKING_FAIL,
  payload: error,
})

export const deleteLabRequestTracking = labRequestTracking => ({
  type: DELETE_LABREQUESTTRACKING,
  payload: labRequestTracking,
})

export const deleteLabRequestTrackingSuccess = id => ({
  type: DELETE_LABREQUESTTRACKING_SUCCESS,
  id,
})

export const deleteLabRequestTrackingFail = error => ({
  type: DELETE_LABREQUESTTRACKING_FAIL,
  payload: error,
})

export const getLabRequestTracking = () => ({
  type: GET_LABREQUESTTRACKING,
})

export const getLabRequestTrackingSuccess = labRequestTracking => ({
  type: GET_LABREQUESTTRACKING_SUCCESS,
  payload: labRequestTracking,
})

export const getLabRequestTrackingFail = error => ({
  type: GET_LABREQUESTTRACKING_FAIL,
  payload: error,
})
